module.exports = __webpack_public_path__ + "static/img/1_2_4.c573feb7.jpg";